// Eigenes CSS
import '../css/style.scss';

// Einfach mal hallo sagen
//console.log('Hallo Welt');

import $ from 'jquery';
window.$ = window.jQuery = $;
//const $ = require('jquery');
//window.$ = window.jQuery = $;







//console.log(window.jQuery === $); // sollte true seinç
//import 'mmenu-js/dist/mmenu';
//import 'slideout/dist/slideout';
//import 'zeynepjs';
//import 'zeynepjs/dist/zeynep';
//import 'zeynepjs';
require('zeynepjs/dist/zeynep.min.js');
//import 'zeynepjs/dist/zeynep.min.js';

//import 'superfish/src/js/superfish';
//import 'superfish';
require('superfish/src/js/superfish');
//console.log('superfish?');
//console.log(typeof $.fn.superfish); 

import 'jquery-match-height/dist/jquery.matchHeight-min';
//import 'swiper/swiper-bundle';
import Swiper, { Navigation, Pagination, Autoplay, Lazy } from 'swiper';
//SwiperCore.use([Autoplay]);
Swiper.use([Autoplay, Pagination, Navigation]);


import 'jquery-ui/ui/position';

//import 'bootstrap/js/dist/collapse';


//import 'imagesloaded/imagesloaded';
//import 'isotope-layout/dist/isotope.pkgd.js';
//import 'isotope-layout';
//var Isotope = require('isotope-layout/dist/isotope.pkgd');
import Isotope from 'isotope-layout';
import Plyr from 'plyr';
//const player = new Plyr('.player');
const players = Plyr.setup('.player');





//import 'resize-observer/dist/resize-observer';

//import Chart from 'chart.js/auto';

// import Chart from 'chart.js/auto';



//var fd_page = document.getElementsByTagName("html")[0];
//fd_page.style.opacity = "0";

/****************  INIT  *****************************/

var App = function ( ) {

    function initPageload() {
        //console.log("Pageload");
        jQuery('html').css("opacity", "0.0");
        jQuery('html').fadeTo(300, 1);
    }

    function initSuperfish() { 
        //console.log("Superfish");
       // jQuery('ul.wpb-sf-menu').css('background-color','#ffff00');
       // jQuery('.fd-header-main-navigation ul').css('background-color','#ddff00');
       // jQuery('#wpb--menu').superfish({});
        /*
        jQuery('.wpb-fdtest').superfish({
            delay:       1000,                            // one second delay on mouseout
            animation:   {opacity:'show',height:'show'},  // fade-in and slide-down animation
            speed:       'fast',                          // faster animation speed
            cssArrows: false
        });
        */
       
        jQuery('ul.sf-menu').superfish({
            delay: 400,
            animation: { opacity: 'show', height: 'show' },
            speed: 200
            
          });
          
    }



    function initShrinkedHeader() {
        let shrink_active = false;
        jQuery(window).scroll(function () {
            var windowwidth = jQuery(window).width();
            //console.log("windowwidth: " + windowwidth);

            if (jQuery(window).scrollTop() > 125) {
                jQuery('#fd-header').addClass('header-shrinked');
                jQuery('body').addClass('body-shrinked');
                //console.log("shrinked");
            } else if (jQuery(window).scrollTop() < 125) {
                jQuery('#fd-header').removeClass('header-shrinked');
                jQuery('body').removeClass('body-shrinked');
            }

            if (jQuery(window).scrollTop() > 125) {
                jQuery('#fd-page').addClass('main-shrinked');
            } else if (jQuery(window).scrollTop() < 125) {
                jQuery('#fd-page').removeClass('main-shrinked');
            }

        });

    }

    

    function initRefreshAfterResize() {
        var dwidth = jQuery(window).width();
        jQuery(window).bind('resize', function(e){
            var wwidth = jQuery(window).width();
            if(dwidth!==wwidth){
            dwidth = jQuery(window).width();
            if (window.RT) clearTimeout(window.RT);
            window.RT = setTimeout(function(){
                this.location.reload(false); /* false to get page from cache */
            }, 1000);
        }
        });
    }

    function initMatchHeight() {
        //console.log("match Height");
        
        jQuery(' .fd_style--3-Col h2 ').matchHeight({byRow: true});
        jQuery(' .fd_style--3-Col .fd_txtimg_style--3col-content-sameheight ').matchHeight({byRow: true});
        jQuery(' .fd_container--Produkt-2er-col h4 ').matchHeight({byRow: true});
        jQuery(' .fd_container--Produkt-2er-col ul ').matchHeight({byRow: true});

        jQuery(' .widget_referenzen_slider_widget .swiper-slide ').matchHeight({byRow: false});
        
        //jQuery(' .post ').matchHeight({byRow: true});
        //jQuery(' #home-introteaser-col .txt ').matchHeight({byRow: true});
    }


    function initTooltips() {
        jQuery(function () {
            //jQuery('[data-toggle="tooltip-right"]').tooltip({placement: 'right', html: true});
            //jQuery('[data-toggle="tooltip-top"]').tooltip({placement: 'top', html: true, trigger: 'hover'});
            //jQuery('[data-toggle="tooltip-left"]').tooltip("show");
        })
    }

    function forceWindowResize() {
       // console.log("forceWindowResize");
       // newsSwiper.init();
        if (window.dispatchEvent) { // For modern browsers
          window.dispatchEvent(new Event('resize'));
        } else { // For older IE versions
          var event = document.createEvent('Event');
          event.initEvent('resize', true, true);
          window.dispatchEvent(event);
        }
      }


    function initCookiesreopen() {
        //jQuery('.cookiesreopen a').attr("href","javascript: Cookiebot.renew()");
       // console.log("initCookiesreopen");
        jQuery(".borlabs-cookie-preference").on("click", window.BorlabsCookie.openCookiePreference());
    }


    function initCF7Styling() {
        var spans = document.getElementsByClassName("wpcf7-form-control-wrap");
        for(var i=0;i<spans.length;i++)
        {
            var input = spans[i].nextSibling;
            if(input != null)
            {
                if(input.tagName == "LABEL")
                {
                    spans[i].appendChild(input);
                }   
            }   
        }

        let dstext = jQuery(".dsgvo .wpcf7-checkbox .wpcf7-list-item-label").text();
        dstext = dstext.replace("Datenschutzerklärung", "<a href='/datenschutz/'>Datenschutzerklärung</a>");
        //console.log(dstext);
        jQuery(".dsgvo .wpcf7-checkbox .wpcf7-list-item-label").html(dstext);

    }




    function initZeynep() {
        var zeynep = $('.zeynep').zeynep({
            load: function (element, options) {
                //console.log('zeynepjs menu is successfully loaded')
              },
            onClosed: function () {
              // enable main wrapper element clicks on any its children element
              jQuery("body main").attr("style", "");
        
            //  console.log('the <a href="https://www.jqueryscript.net/tags.php?/side menu/">side menu</a> is closed.');
            },
            onOpened: function () {
              // disable main wrapper element clicks on any its children element
              jQuery("body main").attr("style", "pointer-events: none;");
        
              //console.log('the side menu is opened.');
            }
            
        });

        jQuery(".mburger").click(function () {
            if (jQuery("html").hasClass("zeynep-opened")) {
              zeynep.close();
            } else {
              zeynep.open();
            }
        });

        jQuery(".zeynep-overlay").click(function () {
            zeynep.close();
        });
        jQuery("#mobileMenuClose-inner").click(function () {
            zeynep.close();
        });
    }


    

    

    

    function initSwiperSliders() {
        console.log('initSwiperSliders');
        function initswiperfd() {
            //console.log('initswiperfd');
            swiperfd.init();
        }

        var swiperfd = new Swiper(".fdSwiper", {
            modules: [Autoplay, Lazy, Pagination, Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: 'false',
            init: false,
            grabCursor: 'true',
            autoHeight: false,
            autoResize: true,
            resizeReInit: true,
            preloadImages: 1,
            lazy: {
                checkInView: true,
                loadPrevNext: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            on: {
                afterInit: function(swiper) {
                    //console.log('Swiper afterInit');
                    clearTimeout(initswiperfdTimeout);
                }
            },
            /*
            autoplay: {
                delay: 7000,
                disableOnInteraction: false,
            },
            */

            
        });
        const initswiperfdTimeout = setTimeout(initswiperfd, 100);

    }


    function initSwiperSlidersProduct() {
        //console.log('initSwiperSliders');
        function initswiperfdproduct() {
            //console.log('initswiperfd');
            swiperfdproduct.init();
        }

        var swiperfdproduct = new Swiper(".fdSwiperProduct", {
            modules: [Autoplay, Lazy, Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: 'true',
            init: false,
            grabCursor: 'true',
            autoHeight: false,
            autoResize: true,
            resizeReInit: true,
            preloadImages: 1,
            lazy: {
                checkInView: true,
                loadPrevNext: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            on: {
                afterInit: function(swiper) {
                    //console.log('Swiper afterInit');
                    clearTimeout(initswiperfdTimeoutProduct);
                }
            },
            /*
            autoplay: {
                delay: 7000,
                disableOnInteraction: false,
            },
            */

            
        });
        const initswiperfdTimeoutProduct = setTimeout(initswiperfdproduct, 100);

    }






    function initHideMenuOnScrollDown() {
        $(document).on("scroll", function(){
            //var windowwidth = jQuery(window).width();
            //console.log("windowwidth: " + windowwidth);

            if (jQuery(window).scrollTop() > 175) {
                jQuery('#fd-header').addClass('header-up');
                //jQuery('body').addClass('body-shrinked');
                //console.log("header-up");
                
            } 
                /* else if (jQuery(window).scrollTop() < 375) {
                jQuery('#fd-header').removeClass('header-up');
                //jQuery('body').removeClass('body-shrinked');
                console.log("header-down");
            }
                */

        });
    }




    function initShowMenuOnScrollUp() {

        var position = $(window).scrollTop();
        //console.log("initShowMenuOnScrollUp, position: " + position);
        
        $(document).on("scroll", function(){
            var scroll = $(window).scrollTop();
			var windowWidth = window.innerWidth;
			//console.log("windowWidth: " + windowWidth);
			//if (windowWidth > 992) {
                //if ($(document).scrollTop() > $(window).height()){
                    if(scroll > position) {
                        //console.log('scrollDown');
                        //jQuery('#scrollUpMenu').removeClass('aktiv').css('display', 'none');
                        if (jQuery(window).scrollTop() > 375) {
                            jQuery('#fd-header').addClass('header-up');
                        }

                    } else { 
                        //console.log('scrollUp');
                        //jQuery('#scrollUpMenu').addClass('aktiv').css('display', 'block');
                        jQuery('#fd-header').removeClass('header-up');

                    }
                    position = scroll;
                //} else {
                    //jQuery('#scrollUpMenu').removeClass('aktiv').css('display', 'none');
                    //jQuery('#fd-header').addClass('header-up');
                //}
            //}

        });
    };

    function getHashFilter() {
        let hash = document.location.hash;
        // get filter=filterName
        //var matches = location.hash.match( /filter=([^&]+)/i );
        var matches = document.location.hash.match( /([^&]+)/i );
        var hashFilter = matches && matches[1];
        //console.log("func hashFilter: " + hashFilter);
        return hashFilter && decodeURIComponent( hashFilter );
      }



    function initIsotopeBlog() {
        //clearTimeout(reinitIsotopeBlogTimeout);
        if ($('#blog-index').length) {
        let hashFilter = "";
        let hashFilterIso = "*";
        hashFilter = getHashFilter();
        //console.log("hashFilter: " + hashFilter);

        switch(hashFilter) {
            case '#gartenlandschaft':
                hashFilterIso = '.cat-64';
                $('button#blog-cat-64').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            case '#gartenlandschaft-en':
                hashFilterIso = '.cat-125';
                $('button#blog-cat-125').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            case '#hanggarten':
                hashFilterIso = '.cat-92';
                $('button#blog-cat-92').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            case '#hillside-gardens':
                hashFilterIso = '.cat-126';
                $('button#blog-cat-126').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            case '#literatur':
                hashFilterIso = '.cat-69';
                $('button#blog-cat-69').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            case '#literature':
                hashFilterIso = '.cat-127';
                $('button#blog-cat-127').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            case '#presse':
                hashFilterIso = '.cat-67';
                $('button#blog-cat-67').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            case '#press':
                hashFilterIso = '.cat-128';
                $('button#blog-cat-128').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            case '#veranstaltungen':
                hashFilterIso = '.cat-62';
                $('button#blog-cat-62').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            case '#events':
                hashFilterIso = '.cat-124';
                $('button#blog-cat-124').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            case '#video':
                hashFilterIso = '.cat-71';
                $('button#blog-cat-71').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            case '#video-en':
                hashFilterIso = '.cat-129';
                $('button#blog-cat-129').addClass('is-checked').siblings().removeClass('is-checked');
                break;
            default:
                hashFilterIso = '*';
                $('button#blog-cat-alle').addClass('is-checked').siblings().removeClass('is-checked');
        }

        //var $gridblog = $('#blog-index').isotope({

        //var gridblog = document.querySelector('#blog-index');
        let $isoblog = new Isotope( '#blog-index', {
            // options
            itemSelector: '.grid-item',
            percentPosition: true,
            filter: hashFilterIso,
            masonry: {
                columnWidth: '.grid-sizer',
                gutter: '.gutter-sizer'
              }
        });
        // filter items on button click
        $('#blog-filter').on( 'click', 'button', function() {
            let filterValue = $(this).attr('data-filter');
            //console.log("filterValue: " + filterValue);
            $(this).addClass('is-checked').siblings().removeClass('is-checked');
            $isoblog.arrange({ filter: filterValue });

            let setHashFilterValue = "";
            switch(filterValue) {
                
                case '.cat-64':
                    setHashFilterValue = "gartenlandschaft";
                    break;
                case '.cat-125':
                    setHashFilterValue = "gartenlandschaft-en";
                    break;
                case '.cat-92':
                    setHashFilterValue = "hanggarten";
                    break;
                case '.cat-126':
                    setHashFilterValue = "hillside-gardens";
                    break;
                case '.cat-69':
                    setHashFilterValue = "literatur";
                    break;
                case '.cat-127':
                    setHashFilterValue = "literature";
                    break;
                case '.cat-67':
                    setHashFilterValue = "presse";
                    break;
                case '.cat-128':
                    setHashFilterValue = "press";
                    break;
                case '.cat-124':
                    setHashFilterValue = "events";
                    break;
                case '.cat-71':
                    setHashFilterValue = "video";
                    break;
                case '.cat-129':
                    setHashFilterValue = "video-en";
                    break;
                default:
                    setHashFilterValue = "";
            }
            if ($('#blog-index').length) {
                if (setHashFilterValue != "") {
                    window.location.hash = setHashFilterValue;
                } else {
                    history.pushState("", document.title, window.location.pathname + window.location.search);
                }
            }
        });

        }

    }


    


    function reinitIsotopeBlog () {

        const reinitIsotopeBlogTimeout = setTimeout(initIsotopeBlog, 2000);
    }

    if ($('#blog-index').length) {
        window.addEventListener("hashchange", reinitIsotopeBlog);
    }

    function reinitIsotopeProjects () {

        const reinitIsotopeProjectsTimeout = setTimeout(initIsotopeProjects, 2000);
    }

    if ($('#projekte-index').length) {
        window.addEventListener("hashchange", reinitIsotopeProjects);
    }







    function initBurger() {
        //console.log('initBurger');
        $('.mburger').click(function(event) {
            event.stopPropagation();
            // console.log('click: Burger');
            $('body').toggleClass('menu-active');
        });
    }

    function initMenuClose() {
        $('#fd-header').click(function() {
             console.log('click: #fd-header');
            if ($('body').hasClass('menu-active')) {
                $('body').removeClass('menu-active');
                // console.log('click: #fd-header.menu-active');
            }
        });
    }
    
    

    

    return {
        init: function ($) {
            initPageload();
            initSuperfish();
            //initRefreshAfterResize();
            //initShrinkedHeader();
            initMatchHeight();
            //initSwiperNews();
            //initCF7Styling();
            //initCookiesreopen();
            //initTooltips();
            //initZeynep();
            initBurger();
            initHideMenuOnScrollDown();
            if (document.querySelector(".fdSwiper")) {
                initSwiperSliders();
            }
            if (document.querySelector(".fdSwiperProduct")) {
                initSwiperSlidersProduct();
            }

            initShowMenuOnScrollUp();

            initMenuClose();

            //initIsotopeProjects();
            //initIsotopeBlog();

            //initShopBuch();
            //initAgbPopupOpen();

            //initBackLinks();

           // initAgbPopupCloseButton();
           //preventRightClick();
        }
    }
}(jQuery);



$(document).ready(function () {
    //console.log('ready  ??');
    App.init();
});


